module.exports = __webpack_public_path__ + "img/1531582939.946533af.jpg";